import { render } from "./inputsize.vue?vue&type=template&id=9994ed2c"
import script from "./inputsize.vue?vue&type=script&lang=js"
export * from "./inputsize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__